import { FunderStat, PlanterStat } from 'src/server/router/accounts/type'

export interface SeasonalStat {
  season: string
  value: number
}

export const orderSeasonalDataArray = (
  dataArray: (FunderStat | PlanterStat)[] | null
) => {
  if (!dataArray) {
    return
  }
  const seasonalStats = dataArray
    ?.filter((element: { SeasonName: string }) => element.SeasonName !== 'All')
    .map(stat => {
      if (stat.__typename === 'PublicPlanterStat') {
        return {
          season: stat.SeasonName,
          value: stat.TreesApproved
        }
      }
      if (stat.__typename === 'PublicFunderStat') {
        return {
          season: stat.SeasonName,
          value: stat.TreesFunded
        }
      }
      return undefined
    })
    .filter((stat): stat is SeasonalStat => {
      return !!stat
    })

  seasonalStats?.sort((a, b) => {
    const seasonNameA = a.season
    const seasonNameB = b.season
    if (seasonNameA > seasonNameB) {
      return -1
    }
    if (seasonNameA < seasonNameB) {
      return 1
    }

    // names must be equal
    return 0
  })

  // this removes all years where count is 0 AFTER the most recent year with count > 0
  while (seasonalStats[0]?.value === 0) {
    seasonalStats?.shift()
  }

  // this removes all years where count is 0 BEFORE the first year with count > 0
  while (seasonalStats[seasonalStats.length - 1]?.value === 0) {
    seasonalStats?.pop()
  }

  return seasonalStats
}
